export default "__VITE_ASSET__DedduZ52__"